var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 46,
    viewBox: "0 0 70 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48042 30.3359C7.48042 32.9803 8.06084 35.0106 8.81948 36.2388C9.81414 37.8476 11.2977 38.5292 12.8102 38.5292C14.7609 38.5292 16.5456 38.0451 19.9847 33.2886C22.7399 29.4761 25.9864 24.1247 28.1708 20.7698L31.8701 15.0861C34.4398 11.1387 37.4141 6.75068 40.8244 3.77634C43.6085 1.34869 46.6117 0 49.6342 0C54.7087 0 59.5423 2.94063 63.2416 8.45581C67.29 14.496 69.2553 22.1041 69.2553 29.9554C69.2553 34.6228 68.3353 38.0524 66.7698 40.7618C65.2574 43.3821 62.3095 46 57.3507 46V38.5292C61.5966 38.5292 62.6563 34.6276 62.6563 30.1625C62.6563 23.7996 61.1728 16.7382 57.9046 11.6927C55.5853 8.11382 52.5797 5.92702 49.273 5.92702C45.6965 5.92702 42.8185 8.6244 39.5841 13.4339C37.8645 15.9892 36.0992 19.1032 34.1171 22.6171L31.9351 26.4825C27.5518 34.2543 26.4416 36.0245 24.2499 38.9459C20.4086 44.0613 17.1284 46 12.8102 46C7.68754 46 4.44827 43.7819 2.44209 40.4391C0.804398 37.7152 0 34.1412 0 30.0686L7.48042 30.3359Z",
    fill: "#0081FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89844 8.98325C9.32797 3.69686 14.2772 0 19.9537 0C23.2412 0 26.5093 0.972984 29.922 3.75948C33.655 6.80607 37.6336 11.8227 42.5973 20.0907L44.3771 23.0578C48.6736 30.2155 51.1181 33.8979 52.5487 35.6343C54.3887 37.8645 55.6772 38.5292 57.351 38.5292C61.597 38.5292 62.6567 34.6276 62.6567 30.1625L69.2556 29.9554C69.2556 34.6228 68.3356 38.0524 66.7702 40.7618C65.2577 43.3821 62.3098 46 57.351 46C54.2683 46 51.5372 45.3305 48.5171 42.4814C46.1954 40.2946 43.4812 36.4098 41.3931 32.9177L35.1819 22.5424C32.0655 17.3355 29.2067 13.4532 27.5522 11.6951C25.7724 9.8045 23.4844 7.52136 19.8333 7.52136C16.8782 7.52136 14.3687 9.59497 12.2686 12.7668L5.89844 8.98325Z",
    fill: "url(#paint0_linear_20538_91191)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.833 7.52136C16.8779 7.52136 14.3684 9.59497 12.2683 12.7668C9.29874 17.2488 7.48042 23.9248 7.48042 30.3359C7.48042 32.9803 8.06084 35.0106 8.81948 36.2388L2.44209 40.4391C0.804398 37.7152 0 34.1412 0 30.0686C0 22.6628 2.03267 14.944 5.89812 8.98325C9.32764 3.69686 14.2769 0 19.9534 0L19.833 7.52136Z",
    fill: "url(#paint1_linear_20538_91191)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20538_91191",
    x1: 14.6914,
    y1: 28.178,
    x2: 62.3773,
    y2: 30.5864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0064E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0073EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0082FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20538_91191",
    x1: 10.8377,
    y1: 33.4764,
    x2: 10.8377,
    y2: 15.8953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0082FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0064E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeta);
export default __webpack_public_path__ + "static/media/meta.17f4938c71dee66e20486bf8c96beaf8.svg";
export { ForwardRef as ReactComponent };